import changeEmailStore from './store';
import BaseVerifyPassword from '../components/VerifyPassword';

interface VerifyPasswordProps {
  onNext: () => void;
  cancelLink: string;
  onClickCancel?: () => void;
}

function VerifyPassword({
  onNext,
  cancelLink,
  onClickCancel = () => {},
}: VerifyPasswordProps) {
  const [isLoading, getEmailToken] = changeEmailStore((s) => [
    s.isLoading,
    s.getEmailToken,
  ]);

  const handleSubmit = async (password) => {
    const res = await getEmailToken(password);

    if (res?.data) {
      onNext();
    }
  };

  return (
    <BaseVerifyPassword
      isLoading={isLoading}
      onSubmit={handleSubmit}
      cancelLink={cancelLink}
      onClickCancel={onClickCancel}
    />
  );
}

export default VerifyPassword;
